// @flow
import React from 'react';
import ReactDropdown from 'react-dropdown';
import classNames from 'classnames';
import 'react-dropdown/style.css';
import './style.scss';
type Option = {
  value: number | string,
  label: string,
};

type Props = {
  options: Array<Option>,
  value: Option | null,
  onChange: () => void,
  placeholder: string,
  name: string,
  className?: string,
  displayValueOnDropdown?: boolean,
};

export const Dropdown = (props: Props) => {
  const {
    options,
    onChange,
    placeholder,
    className,
    value,
    name,
    mode,
    // ...rest
  } = props;

  const containerClass = classNames(
    'basic-dropdown normal-scroll',
    className,
    mode
  );

  // const selectedOption = value;
  const selectedOption =
    value && value !== '' ? options.find(data => data.value === value) : null;

  return (
    <div className={containerClass}>
      <ReactDropdown
        placeholder={placeholder}
        id={className}
        name={name}
        onChange={onChange}
        options={options}
        value={selectedOption}
        arrowClosed={<span className="arrow-closed" />}
        arrowOpen={<span className="arrow-open" />}
      />
    </div>
  );
};

export default Dropdown;
